import jwtDecode from "jwt-decode";

/**
 * Decodes a JWT's claims without throwing: returns `{}` when the token is
 * missing or malformed. Components decode the session's access token while
 * they render, and sessionExpired() clears localStorage before its redirect
 * lands — a component that re-renders in that gap (an API call's catch
 * setting state, a focus listener) reads no token at all, and jwt-decode
 * throws "Invalid token specified" (Sentry SANDBOX-FRONTEND-4X0).
 *
 * Its own module, with no app imports, so the API client's helpers (e.g.
 * utils/authEventLog) can use it without importing Core/utils/auth, which
 * imports the API client. Core/utils/auth re-exports it.
 *
 * @param {string} token
 * @returns {Object} the token's claims, or `{}`
 */
export const decodeToken = (token) => {
  try {
    return jwtDecode(token) || {};
  } catch (_) {
    return {};
  }
};
